import compose from "ramda/es/compose";
import curry from "ramda/es/curry";
import head from "ramda/es/head";
import keys from "ramda/es/keys";
export const takeFirstKey = compose(head, keys);
export const classNamesForModifierAndDisplay = curry((modifierForDisplay, prefix, suffix, classNamesForModifierOverDisplaysWithPrefix)=>{
    const key = takeFirstKey(modifierForDisplay);
    const modifier = modifierForDisplay[key];
    return classNamesForModifierOverDisplaysWithPrefix(`${prefix ? prefix : ''}${modifier}${suffix ? suffix : ''}`, [
        key
    ]).join(' ');
});
